// 静态路由
const isSpecialDomain = window.location.hostname === 'localhost'
const isMobile=navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
const getHomeComponent=()=> {
    if(isSpecialDomain){
        if(isMobile){
            return  import('../views/mobile/Index.vue') 
        }
        else{
            return import('../views/pages/Index.vue')
        }
    }
    else{
        return import('../views/Index.vue');
    }
  }

export const staticRouter = [
      {
        path:'/',
        component:() => 
            getHomeComponent(),
        meta: { 
            title: 'Lucky Satr | Sushi i køge, Sushi i slagelse, Sushi i greve | Sushi Takeaway & Levering i Køge, Greve og Slagelse',
            description: 'Lucky Satr tilbyder frisk sushi takeaway og levering i Køge, Greve og Slagelse. Bestil online og nyd sushi menus, ruller og japanske favoritter. Vi serverer frisk sushi til takeaway og levering i hele Køge, Greve og Slagelse områderne.',
            keywords: 'sushi, takeaway, levering, køge, greve, slagelse, sushi i køge, sushi i slagelse, sushi i greve, japansk mad, sushi menu, frisk sushi',
            h1Title: 'Lucky Satr –Sushi i køge, Sushi i slagelse, Sushi i greve, Sushi Takeaway & Levering i Køge, Greve og Slagelse'
        }
    },
    {
        path:'/:id',
        component:() => import('../views/Index.vue'),
        meta: { 
            title: 'Lucky Satr | Sushi i køge, Sushi i slagelse, Sushi i greve | Sushi Takeaway & Levering',
            description: 'Bestil frisk sushi online fra Lucky Satr. Vi tilbyder takeaway og leveringstjenester i Køge, Greve og Slagelse. Nyd japansk mad og frisk sushi i hele Køge, Greve og Slagelse områderne.',
            keywords: 'sushi, takeaway, levering, køge, greve, slagelse, sushi i køge, sushi i slagelse, sushi i greve, japansk mad',
        }
    },
    {
        path:'/page/index',
        component:() => import('../views/pages/Index.vue'),
         meta: { 
            title: 'Lucky Satr | Sushi i køge, Sushi i slagelse, Sushi i greve | Sushi Takeaway & Levering i Køge, Greve og Slagelse',
            description: 'Lucky Satr tilbyder frisk sushi takeaway og levering i Køge, Greve og Slagelse. Bestil online og nyd sushi menus, ruller og japanske favoritter. Vi serverer frisk sushi til takeaway og levering i hele Køge, Greve og Slagelse områderne.',
            keywords: 'sushi, takeaway, levering, køge, greve, slagelse, sushi i køge, sushi i slagelse, sushi i greve, japansk mad, sushi menu, frisk sushi',
            h1Title: 'Lucky Satr – Sushi i køge, Sushi i slagelse, Sushi i greve,Sushi Takeaway & Levering i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/coupon/:id',
        component:() => import('../views/coupon/Index.vue'),
        meta: { 
            title: 'Rabatkoder | Sushi i køge, Sushi i slagelse, Sushi i greve | Lucky Satr Tilbud',
            description: 'Se vores seneste rabatkoder og tilbud hos Lucky Satr. Spar på din næste sushi bestilling med vores exclusive Lucky Satr tilbud og rabat.',
            keywords: 'rabatkoder, rabat, sushi tilbud, Lucky Satr tilbud'
        }
    },
    {
        path:'/takeaway/:id',
        component:() => import('../views/pages/IndexView.vue'),
        meta: { 
            title: 'Takeaway Menu | Sushi Menu | Lucky Satr',
            description: 'Gennemse vores takeaway menu og sushi menu, bestil frisk sushi online fra Lucky Satr via vores nemme online bestillingssystem.',
            keywords: 'takeaway menu, sushi menu, online bestilling, frisk sushi'
        }
    },
    {
        path:'/takeaway/paymentSuccess/:id',
        component:() => import('../views/results/PaymentSuccess.vue'),
        meta: { 
            title: 'Betaling Lykkedes | Lucky Satr',
            description: 'Din betaling er blevet succesfuldt behandlet. Tak for din bestilling hos Lucky Satr.',
            keywords: 'betaling lykkedes, ordre bekræftelse, sushi ordre'
        }
    },
    {
        path:'/takeaway/paymentFailed/:id',
        component:() => import('../views/results/PaymentFailed.vue'),
        meta: { 
            title: 'Betaling Mislykkedes | Lucky Satr',
            description: 'Din betaling var ikke succesfuld. Prøv venligst igen eller kontakt os for hjælp.',
            keywords: 'betaling mislykkedes, betaling fejl, sushi ordre'
        }
    },
    {
        path:'/takeaway/cartList/:id',
        component:() => import('../views/pages/CartListView.vue'),
        meta: { 
            title: 'Leveringstid | Lucky Satr',
            description: 'Vælg din leveringstid og afslut din ordre hos Lucky Satr.',
            keywords: 'leveringstid, ordre afslutning, sushi levering'
        }
    },
    {
        path:'/takeaway/buyerInfo/:id',
        component:() => import('../views/pages/BuyerInfoView.vue'),
        meta: { 
            title: 'Leveringsoplysninger | Lucky Satr',
            description: 'Indtast dine leveringsoplysninger og afslut din ordre hos Lucky Satr.',
            keywords: 'leveringsoplysninger, ordredetaljer, sushi levering'
        }
    },
    {
        path:'/contact/:tempId/:customId/:id',
        component:() => import('../views/pages/BookingTable.vue'),
        meta: { 
            title: 'Kontakt & Booking | Lucky Satr',
            description: 'Kontakt Lucky Satr og lav en bordreservation til dit næste besøg.',
            keywords: 'kontakt, booking, bordreservation, sushi restaurant'
        }
    },
    {
        path:'/info/:tempId/:customId/:id',
        component:() => import('../views/pages/CustomView.vue'),
        meta: { 
            title: 'Information | Lucky Satr',
            description: 'Lær mere om Lucky Satr, vores menu og tjenester.',
            keywords: 'information, om os, sushi restaurant, tjenester'
        }
    },
    {
        path:'/allyoucaneat/:tempId/:customId/:id',
        component:() => import('../views/pages/AllYouCanEat.vue'),
        meta: { 
            title: 'All You Can Eat | Lucky Satr',
            description: 'Nyd vores all-you-can-eat sushi menu hos Lucky Satr. Ubegrænset sushi til en fast pris.',
            keywords: 'all you can eat, ubegrænset sushi, fast pris, sushi buffet'
        }
    },
    {
        path:'/register/:tempId/:id',
        component:() => import('../views/pages/Register.vue'),
        meta: { 
            title: 'Registrering | Lucky Satr',
            description: 'Opret en konto hos Lucky Satr for at nyde hurtigere checkout og ordrehistorie.',
            keywords: 'registrering, opret konto, sushi ordre, hurtigere checkout'
        }
    },
    {
        path:'/login/:tempId/:id',
        component:() => import('../views/pages/Login.vue'),
        meta: { 
            title: 'Login | Lucky Satr',
            description: 'Log ind på din Lucky Satr konto for at få adgang til din ordrehistorie og præferencer.',
            keywords: 'login, konto adgang, ordrehistorie, præferencer'
        }
    },
    {
        path:'/userCenter/:tempId/:id',
        component:() => import('../views/pages/UserCenter.vue'),
        meta: { 
            title: 'Brugercenter | Lucky Satr',
            description: 'Administrer din konto, se ordrehistorie og opdater dine præferencer hos Lucky Satr.',
            keywords: 'brugercenter, konto administration, ordrehistorie, præferencer'
        }
    },
    //mobile
    {
        path:'/mobile/index',
        component:() => import('../views/mobile/Index.vue'),
        meta: { 
            title: 'Lucky Satr | Sushi i køge, Sushi i slagelse, Sushi i greve | Sushi Takeaway & Levering i Køge, Greve og Slagelse',
            description: 'Lucky Satr tilbyder frisk sushi takeaway og levering i Køge, Greve og Slagelse. Bestil online via vores mobile app og nyd sushi menus, ruller og japanske favoritter. Vi serverer frisk sushi til takeaway og levering i hele Køge, Greve og Slagelse områderne.',
            keywords: 'sushi, takeaway, levering, køge, greve, slagelse, sushi i køge, sushi i slagelse, sushi i greve, japansk mad, sushi menu, frisk sushi, mobil',
            h1Title: 'Lucky Satr - Sushi i køge, Sushi i slagelse, Sushi i greve, Sushi Takeaway & Levering i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/login/:id',
        component:() => import('../views/mobile/Login.vue'),
         meta: { 
            title: 'Login | Konto Adgang | Lucky Satr',
            description: 'Log ind på din Lucky Satr konto for at få adgang til din ordrehistorie og præferencer. Håndter dine præferencer og se din ordrehistorie på vores mobile platform.',
            keywords: 'login, konto adgang, ordrehistorie, præferencer, mobil',
            h1Title: 'Lucky Satr – Sushi Takeaway & Levering i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/userCenter/:id',
        component:() => import('../views/mobile/UserCenter.vue'),
        meta: { 
            title: 'Brugercenter | Konto Administration | Lucky Satr',
            description: 'Administrer din konto, se ordrehistorie og opdater dine præferencer hos Lucky Satr. Håndter din konto administration og se din ordrehistorie på vores mobile platform.',
            keywords: 'brugercenter, konto administration, ordrehistorie, præferencer, mobil',
            h1Title: 'Lucky Satr – Sushi Takeaway & Levering i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/userInfo/:id',
        component:() => import('../views/mobile/UserInfo.vue'),
         meta: { 
            title: 'Brugeroplysninger | Personlige Detaljer | Lucky Satr',
            description: 'Opdater dine personlige oplysninger og præferencer hos Lucky Satr. Håndter dine personlige detaljer og præferencer på vores mobile platform.',
            keywords: 'brugeroplysninger, personlige detaljer, præferencer, mobil',
            h1Title: 'Lucky Satr – Sushi Takeaway & Levering i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/forget/:id',
        component:() => import('../views/mobile/Forget.vue'),
         meta: { 
            title: 'Glemt Kodeord | Nulstil Kodeord | Lucky Satr',
            description: 'Nulstil dit kodeord for din Lucky Satr konto. Genopret din konto adgang via vores mobile platform.',
            keywords: 'glemt kodeord, nulstil kodeord, konto genoprettelse, mobil',
            h1Title: 'Lucky Satr – Sushi Takeaway & Levering i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/myOrder/:id',
        component:() => import('../views/mobile/MyOder.vue'),
         meta: { 
            title: 'Mine Ordre | Ordrehistorie | Lucky Satr',
            description: 'Se din ordrehistorie og spore dine aktuelle ordre hos Lucky Satr. Håndter og spor dine ordre via vores mobile platform.',
            keywords: 'mine ordre, ordrehistorie, spor ordre, mobil',
            h1Title: 'Lucky Satr – Sushi Takeaway & Levering i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/takeaway/:id',
        component:() => import('../views/mobile/IndexView.vue'),
         meta: { 
            title: 'Takeaway Menu | Sushi Menu | Lucky Satr',
            description: 'Gennemse vores takeaway menu og sushi menu, bestil frisk sushi online fra Lucky Satr via vores mobile platform.',
            keywords: 'takeaway menu, sushi menu, online bestilling, frisk sushi, mobil',
            h1Title: 'Lucky Satr – Sushi Takeaway & Levering i Køge, Greve og Slagelse' 
        }
    },
    {
        name:'mobileFoodList',
        path:'/mobile/takeaway/foodlist/:id',
        component:() => import('../views/mobile/FoodListView.vue'),
         meta: { 
            title: 'Madliste | Sushi Menu | Lucky Satr',
            description: 'Gennemse vores madmenu og sushi menu, vælg dine favorit sushi varer hos Lucky Satr via vores mobile platform.',
            keywords: 'madliste, sushi menu, vælg varer, mobil',
            h1Title: 'Lucky Satr – Sushi Takeaway & Levering i Køge, Greve og Slagelse' 
        }
    },
   
    {
        path:'/mobile/takeaway/cartlist/:id',
        component:() => import('../views/mobile/CartListView.vue'),
        meta: { 
            title: 'Indkøbskurv | Ordre Gennemse | Lucky Satr',
            description: 'Gennemse din ordre, foretag ændringer og gennemfør checkout hos Lucky Satr via vores mobile platform.',
            keywords: 'indkøbskurv, ordre gennemse, checkout, mobil',
            h1Title: 'Lucky Satr – Sushi Takeaway & Levering i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/takeaway/time/:id',
        component:() => import('../views/mobile/TimeView.vue'),
        meta: { 
            title: 'Leveringstid | Lucky Satr',
            description: 'Vælg din foretrukne leveringstid for din sushi ordre hos Lucky Satr.',
            keywords: 'leveringstid, vælg tid, sushi levering, mobil',
            h1Title: 'Lucky Satr – Sushi Takeaway & Levering i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/takeaway/buyerInfo/:id',
        component:() => import('../views/mobile/BuyerInfoView.vue'),
         meta: { 
            title: 'Leveringsoplysninger - Lucky Satr',
            description: 'Indtast dine leveringsoplysninger og afslut din ordre hos Lucky Satr.',
            keywords: 'leveringsoplysninger, ordredetaljer, sushi levering, mobil',
            h1Title: 'Lucky Satr – Sushi Takeaway & Levering i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/takeaway/success/:id',
        component:() => import('../views/mobile/OrderSuccessView.vue'),
         meta: { 
            title: 'Ordre Lykkedes | Lucky Satr',
            description: 'Din ordre er blevet succesfuldt placeret. Tak for at vælge Lucky Satr.',
            keywords: 'ordre lykkedes, ordre bekræftelse, sushi ordre, mobil',
            h1Title: 'Lucky Satr – Sushi Takeaway & Levering i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/takeaway/detail/:id',
        component:() => import('../views/mobile/OrderDetailsView.vue'),
       meta: { 
            title: 'Ordredetaljer | Lucky Satr',
            description: 'Se detaljerne af din ordre hos Lucky Satr.',
            keywords: 'ordredetaljer, ordre information, sushi ordre, mobil',
            h1Title: 'Lucky Satr – Sushi Takeaway & Levering i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/contact/:tempId/:customId/:id',
        component:() => import('../views/mobile/BookingTable.vue'),
        meta: { 
            title: 'Kontakt & Booking | Lucky Satr',
            description: 'Kontakt Lucky Satr og lav en bordreservation til dit næste besøg.',
            keywords: 'kontakt, booking, bordreservation, sushi restaurant, mobil',
            h1Title: 'Lucky Satr – Sushi Takeaway & Levering i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/allyoucaneat/:tempId/:customId/:id',
        component:() => import('../views/mobile/AllYouCanEat.vue'),
         meta: { 
            title: 'All You Can Eat | Lucky Satr',
            description: 'Nyd vores all you can eat sushi menu hos Lucky Satr. Ubegrænset sushi til en fast pris.',
            keywords: 'all you can eat, ubegrænset sushi, fast pris, sushi buffet, mobil',
            h1Title: 'Lucky Satr – Sushi Takeaway & Levering i Køge, Greve og Slagelse' 
        }
    },
    //demo 
    {
        path:'/mobile/takeaway/:id/:foodTypeId',
        component:() => import('../views/mobile/IndexView.vue'),
         meta: { 
            title: 'Takeaway Menu | Lucky Satr',
            description: 'Gennemse vores takeaway menu efter kategori og bestil frisk sushi online fra Lucky Satr.',
            keywords: 'takeaway menu, sushi menu, online bestilling, frisk sushi, mobil, madkategori',
            h1Title: 'Lucky Satr – Sushi Takeaway & Levering i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/takeaway/foodlist/:id/:foodTypeId/:foodTypeName/:showType',
        component:() => import('../views/mobile/FoodListView.vue'),
         meta: { 
            title: 'Madliste | Lucky Satr',
            description: 'Gennemse vores madmenu efter kategori og vælg dine favorit sushi varer hos Lucky Satr.',
            keywords: 'madliste, sushi menu, vælg varer, mobil, madkategori',
            h1Title: 'Lucky Satr – Sushi Takeaway & Levering i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/takeaway/time/:id/:deliveryTip',
        component:() => import('../views/mobile/TimeView.vue'),
         meta: { 
            title: 'Leveringstid | Lucky Satr',
            description: 'Vælg din foretrukne leveringstid for din sushi ordre hos Lucky Satr.',
            keywords: 'leveringstid, vælg tid, sushi levering, mobil, leveringsbetingelser',
            h1Title: 'Lucky Satr – Sushi Takeaway & Levering i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/takeaway/buyerInfo/:id/:deliveryTip',
        component:() => import('../views/mobile/BuyerInfoView.vue'),
         meta: { 
            title: 'Leveringsoplysninger | Lucky Satr',
            description: 'Indtast dine leveringsoplysninger og afslut din ordre hos Lucky Satr.',
            keywords: 'leveringsoplysninger, ordredetaljer, sushi levering, mobil, leveringsbetingelser',
            h1Title: 'Lucky Satr – Sushi Takeaway & Levering i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/info/:tempId/:customId/:id',
        component:() => import('../views/mobile/CustomView.vue'),
         meta: { 
            title: 'Information | Lucky Satr',
            description: 'Lær mere om Lucky Satr, vores menu og tjenester.',
            keywords: 'information, om os, sushi restaurant, tjenester, mobil',
            h1Title: 'Lucky Satr – Sushi Takeaway & Levering i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/b/takeaway/:id',
        component:() => import('../views/takeaway02/IndexView.vue'),
        meta: { 
            title: 'Takeaway| Sushi i køge, Sushi i slagelse, Sushi i greve | Lucky Satr',
            description: 'Bestil frisk sushi online fra Lucky Satr. Vi tilbyder takeaway og leveringstjenester.',
            keywords: 'takeaway, online bestilling, frisk sushi, leveringstjenester'
        }
    },
    {
        path:'/b/checkout/:id',
        component:() => import('../views/takeaway02/Checkout.vue'),
        meta: { 
            title: 'Checkout | Sushi i køge, Sushi i slagelse, Sushi i greve| Lucky Satr',
            description: 'Afslut din ordre og foretag betaling hos Lucky Satr.',
            keywords: 'checkout, betaling, ordre afslutning, sushi ordre',
            keepAlive: false 
        }
    },
    {
        path:'/b/order/:id',
        component:() => import('../views/takeaway02/OrderDetial.vue'),
        meta: { 
            title: 'Min Ordre | Lucky Satr',
            description: 'Se detaljerne af din ordre hos Lucky Satr.',
            keywords: 'min ordre, ordredetaljer, ordre information, sushi ordre'
        }
    },
    {
        path:'/b/show/:activeIndex/:id',
        component:() => import('../views/takeaway02/Custom.vue'),
        meta: { 
            title: 'Info | Lucky Satr',
            description: 'Lær mere om Lucky Satr, vores menu og tjenester.',
            keywords: 'info, om os, sushi restaurant, menu, tjenester'
        }
    },
    {
        path:'/b/cartList/:id',
        component:() => import('../views/takeaway02/CartList.vue'),
        meta: { 
            title: 'Kurvliste | Lucky Satr',
            description: 'Gennemse din ordre og foretag ændringer før checkout hos Lucky Satr.',
            keywords: 'kurvliste, ordre gennemse, checkout, sushi ordre'
        }
    },
    {
        path:'/booking/:id',
        component:() => import('../views/booking/Index.vue'),
        meta: { 
            title: 'Booking | Sushi i køge, Sushi i slagelse, Sushi i greve | Lucky Satr',
            description: 'Lav en bordreservation hos Lucky Satr til dit næste besøg.',
            keywords: 'booking, bordreservation, sushi restaurant, reservation'
        }
    },
     {
        path:'/e-invoice/:type/:id',
        component:() => import('../views/bill/Index.vue'),
        meta: { 
            title: 'E-faktura | Lucky Satr',
            description: 'Se og download din e-faktura for din Lucky Satr ordre.',
            keywords: 'e-faktura, faktura, download faktura, ordre faktura'
        }
    },
      {
        path:'/pre-invoice/:type/:id',
        component:() => import('../views/bill/Preview.vue'),
        meta: { 
            title: 'E-faktura Forhåndsvisning | Lucky Satr',
            description: 'Forhåndsvis din e-faktura for din Lucky Satr ordre.',
            keywords: 'e-faktura forhåndsvisning, faktura forhåndsvisning, ordre faktura'
        }
    },
      {
        path:'/booking/edit/:id',
        component:() => import('../views/booking/EditBookingTable.vue'),
        meta: { 
            title: 'Rediger Booking | Lucky Satr',
            description: 'Rediger din bordreservation hos Lucky Satr.',
            keywords: 'rediger booking, modificer reservation, bordreservation'
        }
    },
    {
      path: '/blog/:id',
      name: 'blog',
      component: () => import('@/views/blog/BlogList.vue'),
      meta: { 
            title: 'Blog | Sushi i køge, Sushi i slagelse, Sushi i greve | Lucky Satr',
            description: 'Læs vores seneste blogindlæg om sushi, japansk mad og vores filosofi bag Lucky Satr.',
            keywords: 'blog, sushi, japansk mad, Lucky Satr, køge, greve, slagelse',
            h1Title: 'Lucky Satr – Sushi Takeaway & Levering i Køge, Greve og Slagelse' 
        }
    },
    {
      path: '/blog/detail/:id',
      name: 'blog-detail',
      component: () => import('@/views/blog/BlogDetail.vue'),
      meta: { 
            title: 'Blog Details | Lucky Satr',
            description: 'Læs detaljerede blogindlæg om sushi, japansk mad og vores filosofi bag Lucky Satr.',
            keywords: 'blog details, sushi, japansk mad, Lucky Satr, køge, greve, slagelse',
            h1Title: 'Lucky Satr – Sushi Takeaway & Levering i Køge, Greve og Slagelse' 
        }
    }
]
// 在方法或计算属性中
